import wrapError from "@/components/helpers/wrapError"
import wrapSuccess from "@/components/helpers/wrapSuccess"

export const apiFetchWavelengthEmployees = (funcToDispatch, error, callback) => {
  $.ajax({
    type: "GET",
    url: "/api/internal/wavelengthEmployee",
    success: wrapSuccess(funcToDispatch, callback),
    error: wrapError(error, "apiFetchWavelengthEmployees"),
  })
}

export const apiAddWavelengthEmployee = (email, funcToDispatch, error, callback) => {
  $.ajax({
    type: "POST",
    url: "/api/internal/wavelengthEmployee",
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify({ email }),
    success: wrapSuccess(funcToDispatch, callback),
    error: wrapError(error, "apiAddWavelengthEmployee"),
  })
}

export const apiDeleteWavelengthEmployee = (userId, funcToDispatch, error, callback) => {
  $.ajax({
    type: "DELETE",
    url: `/api/internal/wavelengthEmployee/${userId}`,
    success: wrapSuccess(funcToDispatch, callback),
    error: wrapError(error, "apiDeleteWavelengthEmployee"),
  })
}

export const apiFetchIPAddresses = (funcToDispatch, error, callback) => {
  $.ajax({
    type: "GET",
    url: "/api/internal/ipAddress",
    success: wrapSuccess(funcToDispatch, callback),
    error: wrapError(error, "apiFetchIPAddresses"),
  })
}

export const apiAddIPAddress = (params, funcToDispatch, error, callback) => {
  $.ajax({
    type: "POST",
    url: "/api/internal/ipAddress",
    dataType: "json",
    processData: false,
    contentType: "application/json; charset=utf-8",
    data: JSON.stringify(params),
    success: wrapSuccess(funcToDispatch, callback),
    error: wrapError(error, "apiAddIPAddress"),
  })
}

export const apiDeleteIPAddress = (ipId, funcToDispatch, error, callback) => {
  $.ajax({
    type: "DELETE",
    url: `/api/internal/ipAddress/${ipId}`,
    success: wrapSuccess(funcToDispatch, callback),
    error: wrapError(error, "apiDeleteIPAddress"),
  })
}
